import { Page } from "./Page";
import Path from "../Path";
import { PatternState } from "../patternSlice";
import { Length, multiplyLength, subLengths, lengthToString } from "../length";

export interface PageDimensions {
  width: Length;
  height: Length;
}

interface PatternSectionPagesProps {
  scale: number;
  patterns: PatternState[];
  zoom: number;
  printMiniature?: boolean;

  patternX: number;
  patternY: number;
  patternWidth: number;
  patternHeight: number;
  sectionsVertical: number;
  sectionsHorizontal: number;
  pagesVertical: number;
  pagesHorizontal: number;
  pageDimensions: PageDimensions;
  pageMargin: Length;
  margin: number;
  width: number;
  height: number;
}

export function PatternSectionPages({
  patternX,
  patternY,
  patternHeight,
  patternWidth,
  sectionsVertical,
  sectionsHorizontal,
  pagesVertical,
  pagesHorizontal,
  pageDimensions,
  pageMargin,
  margin,
  width,
  height,
  scale,
  patterns,
  zoom,
  printMiniature,
}: PatternSectionPagesProps) {
  const fontSize = 120;
  let pagesComp = [];

  const pageMarginTotal = multiplyLength(pageMargin, 2);
  const workingPageWidth = subLengths(pageDimensions.width, pageMarginTotal);
  const workingPageHeight = subLengths(pageDimensions.height, pageMarginTotal);

  const workingHeight = patternHeight / sectionsVertical;
  const workingWidth = patternWidth / sectionsHorizontal;
  let pageNumer = 0;
  for (let i = 0; i < pagesVertical; i++) {
    const offsetY = workingHeight * i - margin;
    for (let j = 0; j < pagesHorizontal; j++) {
      const offsetX = workingWidth * j - margin;
      const viewBox = `
          ${patternX + offsetX},
          ${patternY + offsetY},
          ${width},
          ${height}`;
      pageNumer++;

      pagesComp.push(
        <Page key={pageNumer} zoom={zoom} printMiniature={printMiniature}>
          <div
            className="printable-area"
            style={{
              width: lengthToString(workingPageWidth),
              height: lengthToString(workingPageHeight),
              left: lengthToString(pageMargin),
              top: lengthToString(pageMargin),
              position: "absolute",
            }}
          />
          <div
            className="non-printable-area"
            style={{
              width: lengthToString(pageDimensions.width),
              height: lengthToString(pageDimensions.height),
              borderWidth: lengthToString(pageMargin),
            }}
          />
          <div
            style={{
              fontSize: fontSize,
              position: "absolute",
              bottom: 10,
              left: "50%",
            }}
          >
            {pageNumer}
          </div>
          <div
            style={{
              fontSize: fontSize,
              position: "absolute",
              top: 10,
              left: "50%",
            }}
          >
            {pageNumer}
          </div>
          <svg key={i} viewBox={viewBox}>
            {patterns.map((pattern, j) => (
              <Path
                key={j}
                vertices={pattern.vertices}
                mirror={pattern.mirror}
              />
            ))}
          </svg>
        </Page>
      );
    }
  }

  return <>{pagesComp}</>;
}
